export const accountUsersSortFields = {
    email: 'email',
    role: 'role',
    status: 'status',
    name: 'full_name',
};
